import * as yup from 'yup'

const currentDate = new Date()
const yesterday = () => {
  currentDate.setDate(currentDate.getDate() - 1)
  return currentDate
}

const contractSuspendSchema = yup.object().shape({
  reactivationFieldDate: yup
    .date()
    .min(yesterday(), 'Não pode ser uma data no passado'),
})

export default contractSuspendSchema
